import { useState } from 'react';
import Disclaimer from '@App/components/Disclaimer/Disclaimer';

import './footer.styl';

function Footer() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <div className="footer">
      <p className="footer__info">
        {`© Nazka Mapps ${new Date().getFullYear()}`}
        {' | '}
        <a 
          className="footer__info__disclaimer"
          href="https://legal.nazka.be/docs/nl/terms-of-use/ "
          target="_blank"
          rel="noreferrer"
        >
          Gebruiksvoorwaarden
        </a>
        {' | '}
        <button 
          className="footer__info__disclaimer"
          onClick={() => setShowDisclaimer(true)}
          type="button"
        >
          Disclaimer
        </button>
        {' | '}
        <a className="footer__info__email" href="mailto:info@naarjobs.be">
          info@naarjobs.be
        </a>
      </p>
      {showDisclaimer && (
        <Disclaimer setShow={setShowDisclaimer} />
      )}
    </div>
  );
}

export default Footer;